import axios from "axios";
import { errorMessage, tokenExpired } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async getAllDepartments() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/department/get-all/?skip=0&limit=99999`,
          api.getToken()
        );
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  }
};
